<template>
  <div class="container-fluid">
    <div class="contents setting change">
      <tab />

      <b-form @submit="onSubmit">
        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="pills-4"
            role="tabpanel"
            aria-labelledby="pills-4-tab"
          >

            <div class="row g-0 table-type header-col">

              <div class="col-sm-4">
                {{$t("title.setting.tournament")}}
              </div>
              <div class="col-sm-8">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="tournamentopt"
                    name="tournamentopt"
                    v-model="chk_form.tournamentopt_chk"
                  />
                  <label class="form-check-label" for="tournamentopt"
                    >{{ $t("title.setting.available") }}</label
                  >
                </div>
              </div>

              <div class="col-sm-4">
                {{$t("title.setting.minigame")}}
              </div>
              <div class="col-sm-8">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="eventopt"
                    name="eventopt"
                    v-model="chk_form.eventopt_chk"
                  />
                  <label class="form-check-label" for="eventopt">{{ $t("title.setting.available") }}</label>
                </div>
              </div>

              <div class="col-sm-4">
                {{$t("title.setting.booking")}}
              </div>
              <div class="col-sm-8">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="bookingopt"
                    name="bookingopt"
                    v-model="chk_form.bookingopt_chk"
                  />
                  <label class="form-check-label" for="bookingopt">{{ $t("title.setting.available") }}</label>
                </div>
              </div>

              <div class="col-sm-4">
                {{$t("title.setting.operation_hours")}}
              </div>
              <div class="col-sm-8 d-block">
                <div class="row g-0 gap-2">
                  <div class="col p-0">
                    <p class="fw-normal mb-2">{{ $t("title.setting.open") }}</p>
                    <select name="salesstarttime" v-model="form.salesstarttime">
                      <option value="">{{ $t("title.setting.open") }}</option>
                      <option
                        v-for="hours in times"
                        :key="hours + 'o'"
                        :value="hours"
                      >
                        {{ hours }}
                      </option>
                    </select>
                  </div>
                  <div class="col p-0">
                    <p class="fw-normal mb-2">{{ $t("title.setting.close") }}</p>
                    <select name="salesdeadline" v-model="form.salesdeadline">
                      <option value="">{{ $t("title.setting.close") }}</option>
                      <option
                        v-for="hours in times"
                        :key="hours + 'c'"
                        :value="hours"
                      >
                        {{ hours }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

            </div>

            <div class="btn-bottom-wrapper">
              <b-button
                size="xl"
                variant="primary"
                :aria-label="$t('button.common.save')"
                type="submit"
                >{{ $t("button.common.save") }}</b-button
              >
            </div>

          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/setting";
import tab from "@/components/setting/Tab";

export default {
  name: "Option",
  components: {
    tab,
  },
  data() {
    return {
      form: {
        tournamentopt: "",
        eventopt: "",
        bookingopt: "",
        salesstarttime: "",
        salesdeadline: "",
      },
      chk_form: {
        tournamentopt_chk: true,
        eventopt_chk: true,
        bookingopt_chk: true,
      },
      times: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
        20, 21, 22, 23,
      ],
    };
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();

      this.form.bookingopt = this.chk_form.bookingopt_chk === true ? "1" : "0";
      this.form.eventopt = this.chk_form.eventopt_chk === true ? "1" : "0";
      this.form.tournamentopt =
        this.chk_form.tournamentopt_chk === true ? "1" : "0";

      this.set_owneroption();
    },
    set_owneroption() {
      ax.set_owneroption(this.form, (flag, data) => {
        alert(data.message);
      });
    },
    get_owneroptionview() {
      ax.get_owneroptionview((flag, data) => {
        if (flag) {
          this.form = data.owneroptionview;
          this.chk_form.bookingopt_chk =
            this.form.bookingopt === "1" ? true : false;
          this.chk_form.eventopt_chk =
            this.form.eventopt === "1" ? true : false;
          this.chk_form.tournamentopt_chk =
            this.form.tournamentopt === "1" ? true : false;
        } else {
          this.$notify({
            group: "alert",
            type: "warn",
            title: "Notice",
            text: data,
          });
          return false;
        }
      });
    },
  },
  created() {
    this.get_owneroptionview();
  },
};
</script>